
import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

import "animate.css";

const EventThemesBase = () => {
    const themes = [
        {
            title: "Як знайти своїх: гроші, партнери, можливості",
            desc: (
                <>
                    Як перетворити велику ідею на проєкт, знайти людей, які готові
                    повірити в неї, і залучити необхідні ресурси? Як братися за
                    щось більше, коли ставки високі, а готових рецептів немає?
                    Розмова{" "}
                    <strong>
                        про підприємницьке мислення, переговори, довіру
                        інвесторів і партнерів, фінансові та репутаційні ризики,
                        роботу у партнерстві, відповідальність за команду й
                        людей, які залежать від твоїх рішень
                    </strong>.
                </>
            ),
        },
        {
            title: "Сміливість вийти зі своєї «бульбашки»",
            desc: (
                <>
                    Стать не визначає ані можливостей, ані сфери реалізації.
                    Але що відбувається, коли ти опиняєшся в абсолютно новій
                    для себе індустрії? Як наважитися зайти туди, де немає
                    готового досвіду, навчатися на ходу, брати на себе нову
                    відповідальність і поступово знаходити себе в іншій ролі?
                    Поговоримо зі спікерками, які{" "}
                    <strong>
                        вийшли зі своєї професійної «бульбашки» та відкрили
                        для себе нові сфери, можливості й масштаби
                    </strong>.
                </>
            ),
        },
        {
            title: "ШІ for She – нова суперсила чи нова залежність?",
            desc: (
                <>
                    Як перетворити ШІ на особистого помічника, який економить
                    час, допомагає працювати ефективніше, швидше навчатися та
                    знаходити нові рішення? Розберемося,{" "}
                    <strong>як використовувати ШІ</strong> в роботі, навчанні
                    й повсякденному житті, де він справді розширює наші
                    можливості, а де варто зупинитися й не передавати
                    технологіям власне мислення та рішення.
                </>
            ),
        },
        {
            title: "Персональна фінансова подушка: важливо вже сьогодні чи подумаю завтра?",
            desc: (
                <>
                    Як створити власну фінансову опору, не залежати від одного
                    джерела доходу та бути готовою до непередбачуваних змін?
                    Говоримо{" "}
                    <strong>
                        про накопичення, інвестиції, власний капітал,
                        фінансову безпеку, спільний бюджет чи гроші у парі.
                    </strong>
                </>
            ),
        },
        {
            title: "Власна професійна видимість та друга сторона публічності",
            desc: (
                <>
                    Як змінилася поведінка аудиторії та спосіб, у який ми
                    споживаємо інформацію, обираємо, кому довіряти та за ким
                    стежити? Як на це впливають креативність, власний стиль
                    і вміння говорити про важливе по-своєму? Подкасти,
                    YouTube, соцмережі, колонки та інші формати – про те,
                    як бути помітною в інформаційному шумі, формувати
                    навколо себе власну аудиторію та перетворювати
                    персональний бренд на професійний актив.
                </>
            ),
        },
        {
            title: "Хто обирає наш одяг: ми, тренди чи алгоритми?",
            desc: (
                <>
                    Чи стали ми по-іншому вибирати одяг? Як технології
                    допомагають обирати – від AI-стилістів і персональних
                    рекомендацій до віртуальної примірки, аналізу гардероба
                    та resale-платформ? Чи справді ми стали споживати
                    свідоміше і як змінюється сама{" "}
                    <strong>
                        індустрія моди під впливом нової поведінки жінок
                    </strong>.
                </>
            ),
        },
        {
            title: "Longevity: тренд, який стає стилем життя",
            desc: (
                <>
                    Як змінюється культура турботи про себе і які індустрії
                    формують цей тренд: фармацевтика та медицина, жіноче й
                    репродуктивне здоров’я, краса та догляд, оздоровлення,
                    харчування, спорт, медичні технології тощо. Що сьогодні
                    допомагає жінкам довше залишатися активними, добре
                    почуватися та підтримувати якість життя, і куди
                    рухається ринок longevity.
                </>
            ),
        },
    ];

    const cardColors = [
        "bg-[#95C8BF]",
        "bg-[#F5D858]",
        "bg-[#486D97]",
        "bg-[#B43125]",
    ];

    return (
        <section className="mb-16 bg-white md:mb-32">
            <div className="container mx-auto px-4 sm:px-0">
                <ScrollAnimation
                    animateIn="animate__fadeInUp"
                    animateOnce={true}
                >
                    <h2
                        className="mb-8 text-center text-3xl font-bold uppercase
                        text-[#245864] sm:text-4xl md:mb-12
                        lg:text-left lg:text-[60px] lg:leading-[1.1]"
                    >
                        Теми SHE CONGRESS 2026
                    </h2>
                </ScrollAnimation>

                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-8">
                    {themes.map((theme, index) => (
                        <ScrollAnimation
                            key={theme.title}
                            animateIn="animate__fadeInUp"
                            animateOnce={true}
                            className={`h-full min-w-0 xl:col-span-2 ${
                                index === 4 ? "xl:col-start-2" : ""
                            } ${
                                index === 6
                                    ? "sm:col-span-2 sm:mx-auto sm:w-[calc(50%-0.75rem)] xl:col-span-2 xl:mx-0 xl:w-full"
                                    : ""
                            }`}
                        >
                            <article
                                className="flex h-full flex-col border
                                border-[#95C8BF]/50 bg-white
                                p-5 text-[#245864] md:p-6"
                            >
                                <div
                                    className={`mb-5 flex h-14 w-14 shrink-0
                                    items-center justify-center text-[30px]
                                    font-bold leading-none text-white
                                    ${cardColors[index % cardColors.length]}`}
                                >
                                    {String(index + 1).padStart(2, "0")}
                                </div>

                                <h3
                                    className="mb-4 text-[22px] font-bold
                                    leading-[1.25] md:text-[24px]"
                                >
                                    {theme.title}
                                </h3>

                                <div
                                    className="themes-description
                                    text-[16px] leading-[1.55]
                                    md:text-[18px] [&_strong]:font-semibold"
                                >
                                    {theme.desc}
                                </div>
                            </article>
                        </ScrollAnimation>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EventThemesBase;
